<template>
  <div class="users-modern">
    <NavBar />
    <AuthBySessionExpired />
    <NewUser @created="paginate" />
    <NewUserDashboardMonitoring @created="paginate" />

    <!-- Modal de Filtro Modernizado -->
    <b-modal
      id="filter"
      size="md"
      no-close-on-backdrop
      hide-footer
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-filter mr-2"></i>
          Filtrar Usuários
        </div>
      </template>

      <div class="modal-content-modern">
        <div class="filter-form">
          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-toggle-on mr-2"></i>
              Status
            </label>
            <select v-model="status" class="modern-form-select">
              <option value="ATIVO">ATIVO</option>
              <option value="INATIVO">INATIVO</option>
              <option value="TODOS">TODOS</option>
            </select>
          </div>

          <div class="form-actions">
            <v-btn @click="paginate" class="btn-apply-filter">
              <i class="fas fa-filter mr-2"></i>
              Aplicar Filtro
            </v-btn>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="users-container">
      <!-- Header Section -->
      <div class="users-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-users title-icon"></i>
              Usuários
            </h1>
            <p class="page-subtitle">
              Gerencie os usuários e permissões do sistema
            </p>
          </div>

          <div class="actions-section">
            <v-btn
              @click="$bvModal.show('filter')"
              class="btn-filter-modern mr-2"
            >
              <i class="fas fa-filter mr-2"></i>
              Filtrar
            </v-btn>
            <v-btn
              v-if="
                permission('write', 'user') &&
                permission('read', 'dashboard_monitoring')
              "
              class="btn-add-modern mr-2"
              @click="$bvModal.show('new_user_dashboard_monitoring')"
            >
              <i class="fas fa-plus mr-2"></i>
              Adicionar usuário dashboard monitoramento
            </v-btn>
            <v-btn
              v-if="permission('write', 'user')"
              class="btn-add-modern"
              @click="$bvModal.show('new_user')"
            >
              <i class="fas fa-plus mr-2"></i>
              Adicionar
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="users-content">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <!-- Filters Section -->
          <div class="filters-section">
            <div class="filters-card">
              <div class="search-group">
                <label class="search-label">
                  <i class="fas fa-search search-icon"></i>
                  Pesquisar usuários
                </label>
                <v-text-field
                  v-model="search"
                  placeholder="Digite o nome, e-mail ou grupo"
                  outlined
                  dense
                  hide-details
                  class="modern-search-input"
                />
              </div>

              <!-- Status Filter Indicator -->
              <div class="filter-indicators" v-if="status !== 'TODOS'">
                <div class="filter-chip">
                  <i class="fas fa-filter mr-1"></i>
                  Status: {{ status }}
                  <button @click="clearStatusFilter" class="chip-close">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Data Table Section -->
          <div class="table-section">
            <div class="table-card">
              <!-- No Results -->
              <div v-show="users.length == 0" class="no-results">
                <i class="fas fa-users no-results-icon"></i>
                <h3 class="no-results-title">Nenhum usuário encontrado</h3>
                <p class="no-results-text">
                  Tente ajustar os filtros para encontrar resultados
                </p>
              </div>

              <!-- Data Table -->
              <v-data-table
                v-show="users.length > 0"
                v-if="permission('read', 'user')"
                :headers="headers"
                :items="users"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [25, 50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                class="modern-table"
                :no-data-text="'Nenhum usuário encontrado'"
                :loading-text="'Carregando usuários...'"
                @click:row="handleClickRowTable"
              >
                <template v-slot:[`item.status_type_name`]="{ item }">
                  <span
                    class="status-badge"
                    :class="
                      item.status_type_name === 'ATIVO'
                        ? 'status-active'
                        : 'status-inactive'
                    "
                  >
                    <i
                      :class="[
                        'fas mr-1',
                        item.status_type_name === 'ATIVO'
                          ? 'fa-check-circle'
                          : 'fa-times-circle',
                      ]"
                    ></i>
                    {{ item.status_type_name }}
                  </span>
                </template>

                <template v-slot:[`item.has_certificate`]="{ item }">
                  <span
                    v-if="item.dashboard_monitoring == 0"
                    class="status-badge"
                    :class="
                      item.has_certificate == 1
                        ? 'status-active'
                        : 'status-inactive'
                    "
                  >
                    <i
                      :class="[
                        'fas mr-1',
                        item.has_certificate == 1
                          ? 'fa-check-circle'
                          : 'fa-times-circle',
                      ]"
                    ></i>
                    {{ item.has_certificate == 1 ? "Sim" : "Não" }}
                  </span>
                  <span v-if="item.dashboard_monitoring == 1">--</span>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                  <div
                    :class="[
                      'user-name-cell',
                      item.dashboard_monitoring == 1 &&
                        'user-dashboard-monitoring',
                    ]"
                  >
                    <div class="user-avatar">
                      <img
                        v-if="item.photo_url"
                        :src="item.photo_url"
                        :alt="item.name"
                        class="user-photo"
                      />
                      <i v-else class="fas fa-user"></i>
                    </div>
                    <div class="user-details">
                      <div class="user-name">{{ item.name }}</div>
                      <span v-if="item.dashboard_monitoring == 1"
                        >USUÁRIO DASHBOARD MONITORAMENTO</span
                      >
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.email`]="{ item }">
                  <div class="email-cell">
                    <i class="fas fa-envelope mr-2 email-icon"></i>
                    {{ item.email }}
                  </div>
                </template>

                <template v-slot:[`item.user_group_name`]="{ item }">
                  {{
                    item.dashboard_monitoring == 0 ? item.user_group_name : "--"
                  }}
                </template>

                <template v-slot:[`item.user_profile_name`]="{ item }">
                  {{
                    item.dashboard_monitoring == 0
                      ? item.user_profile_name
                      : "--"
                  }}
                </template>
              </v-data-table>
            </div>
          </div>

          <ErrorsMessages :errors="errors" />
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import NewUser from "../templates/Users/NewUser";
import NewUserDashboardMonitoring from "../templates/Users/NewUserDashboardMonitoring";

import api from "../services/api";
import permission from "../lib/permission";
import routes from "../routes";

export default {
  name: "Users",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    NewUser,
    NewUserDashboardMonitoring,
  },
  data() {
    return {
      errors: [],

      users: [],

      status: "ATIVO",

      search: "",

      loading: false,

      headers: [
        { text: "STATUS", value: "status_type_name", width: "120px" },
        { text: "CERTIFICADO", value: "has_certificate", width: "150px" },
        { text: "USUÁRIO", value: "name" },
        { text: "CPF", value: "cpf" },
        { text: "E-MAIL", value: "email" },
        { text: "GRUPO", value: "user_group_name", width: "150px" },
        { text: "PERFIL", value: "user_profile_name", width: "150px" },
      ],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleToBack: () => routes.go(-1),
    handleClickRowTable: ({ id }) =>
      routes.push({ name: "user", params: { id } }),

    clearStatusFilter() {
      this.status = "TODOS";
      this.paginate();
    },

    async retrieve() {
      await this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let params = { status: this.status };

        const response = await api.get("/rest-home/users/paginate", {
          params,
        });

        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }

        this.$bvModal.hide("filter");

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.users-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.users-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.users-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.btn-filter-modern {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(31, 90, 118, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-filter-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(31, 90, 118, 0.4) !important;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

/* Content Section */
.users-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.loading-overlay {
  border-radius: 16px;
}

/* Filters Section */
.filters-section {
  margin-bottom: 8px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
  margin-bottom: 16px;
}

.search-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.search-icon {
  color: #6b7280;
  font-size: 14px;
}

.filter-indicators {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  color: #212121;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #212121;
}

.chip-close {
  background: none;
  border: none;
  color: #212121;
  margin-left: 8px;
  cursor: pointer;
  padding: 0;
  font-size: 10px;
}

.chip-close:hover {
  color: #3730a3;
}

/* Table Section */
.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 64px 24px;
  color: #6b7280;
}

.no-results-icon {
  font-size: 64px;
  color: #d1d5db;
  margin-bottom: 20px;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.no-results-text {
  font-size: 16px;
  color: #6b7280;
}

/* Table Styling */
.modern-table {
  background: transparent !important;
}

.user-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

.email-cell {
  display: flex;
  align-items: center;
  color: #1e293b;
  font-size: 14px;
}

.email-icon {
  color: #6b7280;
  font-size: 12px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.user-dashboard-monitoring {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.filter-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
}

.modern-form-select {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-select:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.btn-apply-filter {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(31, 90, 118, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-apply-filter:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(31, 90, 118, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }

  .actions-section {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .users-container {
    padding: 0 16px;
  }

  .users-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .filters-card,
  .table-card {
    border-radius: 12px;
    padding: 16px;
  }

  .search-group {
    max-width: 100%;
  }

  .user-name-cell {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .user-photo {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 480px) {
  .btn-filter-modern,
  .btn-add-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .actions-section {
    flex-direction: column;
    gap: 8px;
  }
}

/* Override Vuetify styles */
.modern-search-input >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-search-input >>> .v-text-field__slot input {
  font-weight: 500 !important;
  padding: 12px 0 !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
}

.modern-table >>> .v-data-table tbody tr {
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}
</style>